var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"cmsc-page-title theme-border-primary-color"},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }